import { useState } from 'react'

/**
 * Loading + inline-error state for a one-off async submit (login, reset,
 * accept-invite) that reports failures as an error string rather than a toast.
 * Replaces the identical `useState(loading)` + try/catch/finally boilerplate
 * the auth pages each hand-rolled.
 */
export function useAsyncSubmit() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(
    fn: () => Promise<void>,
    fallbackMessage = 'Something went wrong',
  ): Promise<void> {
    setError(null)
    setLoading(true)
    try {
      await fn()
    } catch (err) {
      setError(err instanceof Error ? err.message : fallbackMessage)
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, setError, submit }
}
